import { useHistory } from 'react-router-dom';
import { useCallback, useEffect } from 'react';
import { useProperty, useSiteContext, useTranslation } from '@eti/providers';
import RedirectFromBrandToBrand from './RedirectFromBrandToBrand';

const OrderLoginRedirection = () => {
  const history = useHistory();
  const { brand } = useSiteContext();
  const { p } = useProperty();
  const { t } = useTranslation();
  const toBrand = history?.location?.state?.brand;

  const redirectToBrandUrl = useCallback(() => {
    if (toBrand?.url) {
      window.location.assign(toBrand.url);
    }
  }, [toBrand?.url]);

  useEffect(() => {
    const redirectionTimeInMills =
      p('IbeClient.RedirectCustomerToAnotherSite.Duration') * 1000 || 5000;
    const timeout = setTimeout(redirectToBrandUrl, redirectionTimeInMills);

    return () => clearTimeout(timeout);
  }, [p, redirectToBrandUrl]);

  return (
    <RedirectFromBrandToBrand
      dataTestId="order-login-redirection"
      fromBrandCode={brand.code}
      handleOnClick={redirectToBrandUrl}
      subtitle={t('IbeClient.RedirectCustomerToAnotherSite.FromOrderLogin.Text', toBrand?.name)}
      title={t('IbeClient.RedirectCustomerToAnotherSite.FromOrderLogin.Header')}
      toBrandCode={toBrand?.code}
    />
  );
};

export default OrderLoginRedirection;
